import React, {useRef, useState} from 'react';

import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import {useTranslation} from "react-i18next";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {v4 as uuidv4} from "uuid";

function getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height,
    );

    // As a blob
    return new Promise((resolve, reject) => {
        canvas.toBlob(blob => {
            blob.name = fileName;
            resolve(blob);
        }, 'image/jpeg', 1);
    });
}

const initialCrop = {
    unit: '%',
    width: 100,
    aspect: 16 / 9,
}
const CropImages = ({handleCancel, handleApprove, isOpen, src}) => {
    const [crop, setCrop] = useState(initialCrop)
    const imageRef = useRef();
    const {t} = useTranslation()
    return <Dialog
        dir={'ltr'}
        open={isOpen}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title2"
        aria-describedby="alert-dialog-description2"
    >
        <DialogTitle id="alert-dialog-title2">{t('edit-picture')}</DialogTitle>
        <DialogContent>
            <DialogContentText id="alert-dialog-description2">
                <ReactCrop
                    src={src}
                    crop={crop}
                    ruleOfThirds
                    onImageLoaded={image => {
                        imageRef.current = image;
                    }}
                    onChange={setCrop}
                />
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleCancel} color="primary" variant={"outlined"}>
                {t('doesnt-matter')}
            </Button>
            <Button onClick={async (e) => {
                const croppedImage = await getCroppedImg(imageRef.current, crop, uuidv4())
                handleApprove(e, croppedImage);
            }} color="primary" variant={"contained"} autoFocus>
                {t('i-finished')}
            </Button>
        </DialogActions>
    </Dialog>
}

export default CropImages;